module.exports = __webpack_public_path__ + "static/media/exyte.804e6da7.png";